import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'src/libs/axios';
import { QueryOptions } from 'src/libs/react-query';
import { leaderboardKeys } from './leaderboard-keys';
import { UserStats } from './get-current-leaderboard';

export interface Participant {
  rank: number;
  user_id: string;
  wallet_address: string;
  account_equity: number;
  volume: number;
  pnl: number;
  roi: number;
  points: number;
  tier: string;
}

export interface PreseasonLeaderboardResponse {
  start_date: string;
  end_date: string;
  participants: Participant[];
  total: number;
  page_size: number;
  page_number: number;
  user?: UserStats;
}
export interface GetPreSeasonLeaderboardParams {
  page: number;
  page_size: number;
  user?: string;
}

export const getPreseasonLeaderboard = async (params: GetPreSeasonLeaderboardParams) => {
  const response = await apiClient.get<PreseasonLeaderboardResponse>('/v1/public/user-leaderboard/pre-season', {
    params,
  });

  return response.data;
};

export type UseGetPreseasonLeaderboard<TData, TError> = QueryOptions<
  PreseasonLeaderboardResponse,
  TError,
  PreseasonLeaderboardResponse,
  ReturnType<typeof leaderboardKeys.getPreseasonLeaderboard>
>;

export const useGetPreseasonLeaderboard = <TData = PreseasonLeaderboardResponse, TError = Error>(
  params: GetPreSeasonLeaderboardParams,
  options?: UseGetPreseasonLeaderboard<TData, TError>,
) => {
  return useQuery({
    queryKey: leaderboardKeys.getPreseasonLeaderboard(params),
    queryFn: () => getPreseasonLeaderboard(params),
    enabled: true,
    ...options,
  });
};
